import { Component, Input } from '@angular/core';
import { Ride } from '../../../../models/ride';
import { DatePipe } from '@angular/common';
import { CapitalizePipe } from '../../../../@pipes/capitalize-pipe';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-ride-details-billings',
  imports: [DatePipe, CapitalizePipe, PaginatorModule],
  templateUrl: './ride-details-billings.html',
  styleUrl: './ride-details-billings.scss'
})
export class RideDetailsBillings {

  @Input() rideDetails!: Ride

  first = 0
  rows = 20

  get pagedBillings() {
    return this.rideDetails.billings?.slice(this.first, this.first + this.rows) ?? []
  }

  get totalRecords() {
    return this.rideDetails.billings?.length ?? 0
  }

  get hasOperationalCharge() {
    return this.rideDetails.billings?.some(b => b.operationalCharge !== null && b.operationalCharge !== undefined) ?? false
  }

  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0
    this.rows = event.rows ?? 10
  }
}
